import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["star", "connector", "input", "description", "submitButton"]
  static values = {
    score: { type: Number, default: 0 },
    descriptions: Array
  }

  connect() {
    this.render()
  }

  select(event) {
    const value = parseInt(event.currentTarget.dataset.value)
    this.scoreValue = value
    this.inputTarget.value = value
    this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }))
    this.render()
  }

  mouseenter(event) {
    const value = parseInt(event.currentTarget.dataset.value)
    this.highlightUpTo(value)
    this.descriptionTarget.textContent = this.descriptionsValue[value - 1] || ""
  }

  mouseleave() {
    this.render()
  }

  render() {
    this.highlightUpTo(this.scoreValue)
    if (this.scoreValue > 0) {
      this.descriptionTarget.textContent = this.descriptionsValue[this.scoreValue - 1] || ""
    } else {
      this.descriptionTarget.textContent = ""
    }
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.classList.toggle("btn-disabled", this.scoreValue === 0)
    }
  }

  highlightUpTo(value) {
    this.starTargets.forEach((star) => {
      const starValue = parseInt(star.dataset.value)
      if (starValue <= value) {
        star.classList.add("text-starring", "border-starring", "bg-starring/10")
        star.classList.remove("text-base-content/20", "border-base-content/20")
      } else {
        star.classList.remove("text-starring", "border-starring", "bg-starring/10")
        star.classList.add("text-base-content/20", "border-base-content/20")
      }
    })

    this.connectorTargets.forEach((connector, index) => {
      if (index + 1 < value) {
        connector.classList.add("bg-starring")
        connector.classList.remove("bg-base-content/20")
      } else {
        connector.classList.remove("bg-starring")
        connector.classList.add("bg-base-content/20")
      }
    })
  }
}
